import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// AppErrorBoundary.tsx
import React from 'react';
import { reportClientError, } from './clientErrorReporter.js';
export class AppErrorBoundary extends React.Component {
    state = {
        hasError: false,
    };
    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }
    componentDidCatch(error, errorInfo) {
        reportClientError({
            type: 'react-error',
            name: error.name,
            message: error.message,
            stack: error.stack,
            componentStack: errorInfo.componentStack ?? undefined,
        });
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("main", { children: [_jsx("h1", { children: "Something went wrong" }), _jsx("button", { onClick: () => window.location.reload(), children: "Reload page" })] }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=AppErrorBoundary.js.map